module.exports = __webpack_public_path__ + "static/media/henrique.e48a49ba.jpg";